import "react-datepicker/dist/react-datepicker.css";
import { MdRemoveRedEye, MdEdit } from "react-icons/md";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { resetSingleClaims } from "../../../../redux/slice/claim/claimSlice";
import { useEffect } from "react";

// main component starts here
const PolicyClaimHistory = ({ claims }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(resetSingleClaims());
  }, []);

  return (
    <>
      <div className='row'>
        <div className='col-12'>
          <div className='position-relative'>
            <div className='row'>
              <div className='col-sm-12'>
                <div className='table-responsive'>
                  <table className='table table-centered table-striped nowrap w-100 no-footer'>
                    <thead>
                      <tr>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "130.8px" }}
                          aria-label='Customer: activate to sort column ascending'
                        >
                          Claims ID
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Policy No.
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Policy Name
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                          aria-label='Email: activate to sort column ascending'
                        >
                          Total Premium
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "206.8px" }}
                          aria-label='Location: activate to sort column ascending'
                        >
                          Claims Amount
                        </th>

                        <th
                          className='sorting sorting_asc'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                        >
                          Status
                        </th>
                        <th
                          className='sorting text-center'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "165.8px" }}
                          aria-label='Status: activate to sort column ascending'
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {claims?.map((item, i) => (
                        <tr key={i}>
                          <td>
                            <span>{item.claim_id}</span>
                          </td>
                          <td>{item?.policy_app_no}</td>
                          <td className=''>{item?.policyName}</td>
                          <td>{item?.total_premium_paid}</td>
                          <td>{item?.claim_amount}</td>
                          <td>
                            <span className='badge badge-success-lighten'>
                              Approved
                            </span>
                            <span className='badge badge-danger-lighten'>
                              {item?.decline_status &&
                              item?.claim_status === "0" &&
                              item?.decline_status !== "0"
                                ? item?.decline_status
                                : null}
                            </span>
                            <span className='badge badge-success-lighten'>
                              {item?.claim_status
                                ? item?.claim_status === "1" && "Approved"
                                : null}
                            </span>
                          </td>

                          <td className='text-center'>
                            <Link
                              to={`/admin/claims/history`}
                              className='text-left'
                              state={{ id: item?.claim_id }}
                              // onClick={() =>
                              //   dispatch(getSingleClaim(item?.claim_id))
                              // }
                            >
                              <MdRemoveRedEye
                                className='text-primary'
                                style={{
                                  fontSize: "20px",
                                  textAlign: "start",
                                }}
                              />
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {claims?.length < 1 ? (
                    <h5 className='alert alert-info'>No result found!</h5>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          {/* <PolicySingleClaimHistoryView /> */}
        </div>
      </div>
    </>
  );
};

export default PolicyClaimHistory;
